import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'simulated.correction.manualStudentSelection.title',
    defaultMessage: 'Select student',
  },
  instruction: {
    id: 'simulated.correction.manualStudentSelection.instruction',
    defaultMessage:
      'The student could not be identified automatically. Please select the student that corresponds to this answer sheet.',
  },
  instructionManyResults: {
    id: 'simulated.correction.manualStudentSelection.instructionManyResults',
    defaultMessage:
      'Sorry, more than one student with the same registration number (RA) as on the answer sheet was found. In this case you need to select the student manually.',
  },
  studentName: {
    id: 'simulated.correction.manualStudentSelection.studentName',
    defaultMessage: 'Student',
  },
  status: {
    id: 'simulated.correction.manualStudentSelection.status',
    defaultMessage: 'Status',
  },
  statusSent: {
    id: 'simulated.correction.manualStudentSelection.statusSent',
    defaultMessage: 'Sent',
  },
  statusPending: {
    id: 'simulated.correction.manualStudentSelection.statusPending',
    defaultMessage: 'Pending',
  },
  back: {
    id: 'simulated.correction.manualStudentSelection.back',
    defaultMessage: 'Back',
  },
  continue: {
    id: 'simulated.correction.manualStudentSelection.continue',
    defaultMessage: 'Continue',
  },
  loading: {
    id: 'simulated.correction.manualStudentSelection.loading',
    defaultMessage: '<div class="manual-student-selection-loading">Please wait... <span class="loading show simple"></span></div>',
  },
  overwriteTitle: {
    id: 'simulated.correction.manualStudentSelection.overwriteTitle',
    defaultMessage: 'Overwrite results?',
  },
  overwriteMessage: {
    id: 'simulated.correction.manualStudentSelection.overwriteMessage',
    defaultMessage:
      'The student "{studentName}" already has an answer sheet loaded. Are you sure you want to overwrite the answers with this new card? This operation is irreversible.',
  },
  cancel: {
    id: 'simulated.correction.manualStudentSelection.cancel',
    defaultMessage: 'Cancel',
  },
  confirmOverwrite: {
    id: 'simulated.correction.manualStudentSelection.confirmOverwrite',
    defaultMessage: 'Continue',
  },
  errorGeneric: {
    id: 'simulated.correction.manualStudentSelection.errorGeneric',
    defaultMessage: 'Error uploading answer sheet',
  },
});
